module.exports = __webpack_public_path__ + "images/percentIcon-a5df7b.svg";